export const TAB_TRANSFER = "TAB_TRANSFER"
export const TAB_TRACK_TRANSFER = "TAB_TRACK_TRANSFER"
export const INVALID_MIN_SOURCE = "INVALID_MIN_SOURCE"
export const INVALID_MAX_SOURCE = "INVALID_MAX_SOURCE"
export const INVALID_MIN_TARGET = "INVALID_MIN_TARGET"
export const INVALID_MAX_TARGET = "INVALID_MAX_TARGET"
